export default __webpack_public_path__ + "static/media/research_04.046350b3.png";